import { type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/store/auth';
import { Icon, I, type IconKey } from '@/components/icons';

const NAV: { to: string; label: string; icon: IconKey }[] = [
  { to: '/platform/tenants', label: '租戶總覽 / 開通', icon: 'building' },
  { to: '/platform', label: '大數據中台', icon: 'globe' },
];

export function PlatformShell({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--bg)' }}>
      <div style={{ width: 220, background: '#1c1a23', color: '#fff', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
        <div style={{ padding: '16px 16px 10px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ width: 28, height: 28, borderRadius: 8, background: '#C9A96A', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>👑</div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700 }}>平台總管理</div>
            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>SaaS Operator Console</div>
          </div>
        </div>
        <div style={{ padding: 10, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 10, padding: '9px 11px', borderRadius: 8,
                color: isActive ? '#fff' : 'rgba(255,255,255,0.65)',
                background: isActive ? 'rgba(201,169,106,0.25)' : 'transparent',
                textDecoration: 'none', fontSize: 13, fontWeight: isActive ? 600 : 400,
              })}
            >
              <Icon d={I[n.icon]} size={15} /> {n.label}
            </NavLink>
          ))}
        </div>
        <div style={{ flex: 1 }} />
        <div style={{ padding: 12, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
          <div style={{ fontSize: 12, marginBottom: 8 }}>{user?.name}</div>
          <button onClick={() => void logout()} style={{ width: '100%', padding: '8px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.2)', background: 'transparent', color: '#fff', cursor: 'pointer', fontSize: 12 }}>登出</button>
        </div>
      </div>
      <div style={{ flex: 1, overflow: 'auto', padding: 24 }}>{children}</div>
    </div>
  );
}
